import React, { useState } from 'react';
import { Tabs } from 'antd';
import WdiCountryMappingTab from './WdiCountryMappingTab';
import WdiIndicatorMappingTab from './WdiIndicatorMappingTab';
import WdiConvertFetchTab from './WdiConvertFetchTab';

const { TabPane } = Tabs;

const WdiTabGroup = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [checkRefreshKey, setCheckRefreshKey] = useState(0);

  const onConvertSuccess = () => {
    setRefreshKey(k => k + 1);
  };

  const onCheckSuccess = () => {
    setCheckRefreshKey(k => k + 1);
  };

  return (
    <Tabs defaultActiveKey="comparison">
      <TabPane tab="Comparison" key="comparison">
        <WdiConvertFetchTab onConvertSuccess={onConvertSuccess} refreshTrigger={checkRefreshKey} />
      </TabPane>
      <TabPane tab="Indicator Mapping" key="indicator">
        <WdiIndicatorMappingTab refreshTrigger={refreshKey} onCheckSuccess={onCheckSuccess} />
      </TabPane>
      <TabPane tab="Country Mapping" key="country">
        <WdiCountryMappingTab />
      </TabPane>
    </Tabs>
  );
};

export default WdiTabGroup;
